import {Box, createTheme, CssBaseline, GlobalStyles, ThemeProvider} from "@mui/material";
import theme from "../theme";
import rtlPlugin from 'stylis-plugin-rtl';
import {CacheProvider} from '@emotion/react';
import createCache from '@emotion/cache';
import {prefixer} from 'stylis';
import useThemeStore from "../store/theme";
import {useMemo} from "react";

const EmptyLayout = ({children}) => {

    const mode = useThemeStore((state) => state.mode);
    // Update the theme only if the mode changes
    const theTheme = useMemo(() => createTheme(theme(mode)), [mode]);

    // Create rtl cache
    const cacheRtl = createCache({
        key: 'muirtl',
        stylisPlugins: [prefixer, rtlPlugin],
    });

    return (
        <CacheProvider value={cacheRtl}>
            <ThemeProvider theme={theTheme}>
                <CssBaseline/>
                <GlobalStyles styles={`@import url("/assets/css/main.css");`}/>
                <Box component="main">
                    {children}
                </Box>
            </ThemeProvider>
        </CacheProvider>
    );
}
export default EmptyLayout;